import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ui-mobile-buttons-skeleton',
  templateUrl: './ui-mobile-buttons-skeleton.component.html',
  styleUrls: ['./ui-mobile-buttons-skeleton.component.scss']
})
export class UiMobileButtonsSkeletonComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }
}
